<div class="billing-assistance-cards" [ngClass]="'cards-count-' + cards?.length">
  <ng-container *ngFor="let card of cards">
    <div class="assistance-card">
      <div class="card-image-wrap">
        <img class="card-image" [src]="card.imageUrl" [alt]="card.imageAlt" />
      </div>
      <div class="card-content">
        <div class="card-title" #titleEl [style.min-height.px]="maxTitleHeight">{{card.title}}</div>
        <div class="card-desc">
          <ng-container *ngIf="card.actionType === 'submitRequest'; else otherDescription">
            <a class="contact-us-link" routerLink='/contact'>Contact us</a> to get help with your billing statement or
            making payments.
          </ng-container>
          <ng-template #otherDescription>
            <span [innerHTML]="card.description"></span>
          </ng-template>
        </div>

        <ng-container [ngSwitch]="card.actionType">
          <ng-container *ngSwitchCase="'sendQuestion'">
            <div class="card-action">
              <app-billing-question [landingFrom]="'billing-assistance-box'" [buttonText]="card.buttonTitle">
              </app-billing-question>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'uploadDocuments'">
            <div class="card-action">
              <app-upload-type-modal></app-upload-type-modal>
            </div>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <div class="card-action">
              <mapfre-button [additionalClasses]="'ghost secondary'" (click)="buttonAction(card)"><span
                  class="button-content">{{card.buttonTitle}}</span>
              </mapfre-button>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>